var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleTooltip)?_c('div',{ref:"tooltipEl",staticClass:"tooltip",class:[{'active': _vm.activeTooltip}, _vm.sideClass]},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }